import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchMyWorkspaces,
  createWorkspace,
  updateWorkspace,
  deleteWorkspace,
} from '../services/workspaceService';
import type { CreateWorkspaceData, UpdateWorkspaceData } from '../services/workspaceService';

export const workspaceKeys = {
  all: ['workspaces'] as const,
};

export function useMyWorkspaces() {
  return useQuery({
    queryKey: workspaceKeys.all,
    queryFn: fetchMyWorkspaces,
  });
}

export function useCreateWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateWorkspaceData) => createWorkspace(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workspaceKeys.all });
    },
  });
}

export function useUpdateWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { workspaceId: string; data: UpdateWorkspaceData }) =>
      updateWorkspace(params.workspaceId, params.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workspaceKeys.all });
    },
  });
}

export function useDeleteWorkspace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (workspaceId: string) => deleteWorkspace(workspaceId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workspaceKeys.all });
    },
  });
}
